export default __webpack_public_path__ + "static/media/logo.df9ae8e8.jpg";